export const normalizeGiftCode = (value: string) => value.replace(/[\s-]/g, '');
export const isValidGiftCode = (value: string) => /^\d{12,16}$/.test(value);

export function extractGiftCode(text: string): string | undefined {
    const codes = [...new Set(text.split(/\r?\n/).map(normalizeGiftCode).filter(isValidGiftCode))];
    return codes.length === 1 ? codes[0] : undefined;
}
